<template>
  <el-container>
    <el-header>
      <el-col :span="20">
        <span>Gestion de Usuarios y Cuadrillas</span>
      </el-col>
      <el-button circle icon="el-icon-refresh" @click="getSync()"></el-button>
    </el-header>
    <el-main>
      <el-table :data="usuario_cuadrilla" style="width: 100%" height="600" stripe>
        <el-table-column label="Usuario" width="300">
          <template slot-scope="scope">
            {{ getNombreUsuario(scope.row.usua_id) }}
          </template>
        </el-table-column>

        <el-table-column label="Contratista" width="280">
          <template slot-scope="scope">
            <el-select
              filterable
              clearable
              ref="contratista"
              v-model="scope.row.cont_id"
              name="contratista"
              placeholder="Selecccione el Contratista"
              style="width:250px;"
              @change="updateContratista(scope.row)"
              @clear="clearContratista(scope.row)"
            >
              <el-option
                v-for="contratista in contratistas"
                :key="contratista.cont_id"
                :label="contratista.cont_nombre"
                :value="contratista.cont_id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="Cuadrilla" width="280">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.cont_id ? true : false"
              filterable
              clearable
              ref="crew"
              v-model="scope.row.cuad_id"
              name="crew"
              :placeholder="$t('cuadrilla.select')"
              style="width:250px;"
              @change="
                update(
                  scope.row.usua_id,
                  scope.row.cuad_id,
                  scope.row.cuus_esresponsable
                )
              "
              @clear="
                update(
                  scope.row.usua_id,
                  scope.row.cuad_id,
                  scope.row.cuus_esresponsable
                )
              "
            >
              <el-option
                v-for="cuadrilla in (contratistas.find(
                  contratista => contratista.cont_id === scope.row.cont_id
                ) || { cuadrillas: [] }).cuadrillas"
                :key="cuadrilla.cuad_id"
                :label="cuadrilla.cuad_descripcion"
                :value="cuadrilla.cuad_id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Responsable" width="180" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.cuus_esresponsable"
              @change="
                update(
                  scope.row.usua_id,
                  scope.row.cuad_id,
                  scope.row.cuus_esresponsable
                )
              "
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>
<script>
  import {
    getUsuariosCuadrilla,
    actualizarUsuarioCuadrilla
  } from '@/api/cuadrilla'
  import { getContratistas } from '@/api/contratista'
  import { getAll } from '@/api/usuario'
  import data from '../../svg-icons/generateIconsView'

  export default {
    name: 'Menu8cuadrilla',
    data() {
      return {
        usuario_cuadrilla: [],
        usuarios: [],
        contratistas: []
      }
    },
    beforeMount() {
      this.getSync()
    },
    methods: {
      getSync() {
        getAll().then(response => {
          this.usuarios = response.data
          getUsuariosCuadrilla().then(response => {
            this.usuario_cuadrilla = response.data
            getContratistas()
              .then(response => {
                this.contratistas = response.data
              })
              .catch(error => {
                console.log('error1', error)
              })
          })
        })
      },
      getNombreUsuario(usua_id) {
        if (usua_id != null && usua_id > 0) {
          var usuario = this.usuarios.find(
            usuario => usuario.usua_id === usua_id,
            { usua_nombre: 'Usuario No Existe', usua_apellido: '' }
          )
          return usuario.usua_nombre + ' ' + usuario.usua_apellido
        } else {
          return 'Sin Usuario'
        }
      },
      updateContratista(row) {
        row.cuad_id = -1
        this.update(row.usua_id, row.cuad_id, row.cuus_esresponsable)
      },
      clearContratista(row) {
        row.cont_id = null
        row.cuad_id = -1
        this.update(row.usua_id, row.cuad_id, row.cuus_esresponsable)
      },
      update(usua_id, cuad_id, cuus_esresponsable) {
        if (cuus_esresponsable === null) cuus_esresponsable = false
        if (cuad_id === null || cuad_id === '') cuad_id = -1
        actualizarUsuarioCuadrilla(usua_id, cuad_id, cuus_esresponsable)
          .then(response => {
            this.$message({
              message: 'Información Actualizada al usuario',
              type: 'success'
            })
          })
          .catch(error => {
            this.$message({
              message: `No se pudo actualizada la información al usuario: ${error}`,
              type: 'error'
            })
          })
      }
    }
  }
</script>
